import React, { useEffect, useRef, useCallback, useState } from "react";
import "./SimpleView.css";
import { Button, Col, Row, Radio, Dropdown, Menu, Checkbox } from "antd";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import {
  BASE_URL,
  FetchAttendanceSimpleView,
  FetchDepartment,
  FetchDesignation,
} from "../../utils/constant";
import { FaAngleDown } from "react-icons/fa6";
import { useSelector } from "react-redux";
import SearchIconColor from "../../assets/icons/search.svg";
import { ExportToExcel } from "../../common/ExportToExcel";
function SimpleView() {
  const gridRef = useRef();
  const designationState = useSelector(
    (state) => state.designation.designation
  );
  const departmentState = useSelector((state) => state.department.department);
  const userInfo = useSelector((state) => state.signUp.signUpDetails);
  const [simpleViewData, setSimpleViewData] = useState([]);
  const [departments, setDepartments] = useState(departmentState);
  const [designation, setDesignation] = useState(designationState);
  const [departmentsSelected, setDepartmentsSelected] = useState();
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [selectedDesignation, setSelectedDesignationt] = useState([]);
  const [simpleExportData, setSimpleExportData] = useState([]);

  const toggleSearchVisibility = () => {
    setIsSearchVisible((prevState) => !prevState);
  };
  const onFilterTextBoxChanged = useCallback(() => {
    gridRef.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("filter-text-box").value
    );
  }, []);
  const capitalizeFirstLetter = (str) => {
    return str?.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const currentYear = new Date().getFullYear();
  const currentDate = new Date();

  const currentMonth = currentDate.getMonth() + 1;
  const currentYearSelected = currentDate.getFullYear();

  const [selectedMonthNumber, setSelectedMonthNumber] = useState(currentMonth);
  const [selectedYearNumber, setSelectedYearNumber] =
    useState(currentYearSelected);
  const BoCreatedAt =
    userInfo?.userRole == "businessOwner"
      ? userInfo?.createdAt
      : userInfo?.boOwner?.createdAt;

  const dynamicDate = new Date(BoCreatedAt);

  let endYear;

  if (currentMonth < 4) {
    endYear = currentYear - 1;
  } else {
    endYear = currentYear;
  }

  const startYear =
    dynamicDate.getMonth() < 3
      ? dynamicDate.getFullYear() - 1
      : dynamicDate.getFullYear();
  const numberOfYears = endYear - startYear + 1;

  const fiscalYear = Array.from({ length: numberOfYears }, (_, index) => {
    const year = startYear + index;
    return `${year}-${year + 1}`;
  });

  console.log(fiscalYear);
  const defaultSelectedMonth = `${
    currentMonth < 10 ? "" : ""
  }${currentMonth}-${currentYear}`;

  const [selectedMonth, setSelectedMonth] = useState(defaultSelectedMonth);

  const currentFiscalYear = `${currentYear}-${currentYear + 1}`;
  const defaultSelectedFiscalYear = fiscalYear.includes(currentFiscalYear)
    ? currentFiscalYear
    : fiscalYear[0];
  const [selectedFiscalYea, setSelectedFiscalYea] = useState(
    defaultSelectedFiscalYear
  );

  const updateMonths = (selectedYear) => {
    const startYear = parseInt(selectedYear?.split("-")[0]);
    const endYear = parseInt(selectedYear?.split("-")[1]);

    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1; // Adding 1 to convert from 0-indexed to 1-indexed
    const dynamicMonth = dynamicDate.getMonth() + 1;
    const months = [];
    if (startYear == dynamicDate.getFullYear()) {
      for (let month = dynamicMonth; month <= 12; month++) {
        if (
          startYear < currentYear ||
          (startYear === currentYear && month <= currentMonth)
        ) {
          months.push(`${month < 10 ? "" : ""}${month}-${startYear}`);
        }
      }

      for (let month = 1; month <= 3; month++) {
        if (
          endYear < currentYear ||
          (endYear === currentYear && month <= currentMonth)
        ) {
          months.push(`${month < 10 ? "" : ""}${month}-${endYear}`);
        }
      }
    } else if (endYear == dynamicDate.getFullYear()) {
      for (let month = dynamicMonth; month <= 3; month++) {
        if (
          endYear < currentYear ||
          (endYear === currentYear && month <= currentMonth)
        ) {
          months.push(`${month < 10 ? "" : ""}${month}-${endYear}`);
        }
      }
    } else {
      for (let month = 4; month <= 12; month++) {
        if (
          startYear < currentYear ||
          (startYear === currentYear && month <= currentMonth)
        ) {
          months.push(`${month < 10 ? "" : ""}${month}-${startYear}`);
        }
      }

      for (let month = 1; month <= 3; month++) {
        if (
          endYear < currentYear ||
          (endYear === currentYear && month <= currentMonth)
        ) {
          months.push(`${month < 10 ? "" : ""}${month}-${endYear}`);
        }
      }
    }

    return months;
  };

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const getMonthName = (monthNumber) => {
    if (monthNumber >= 1 && monthNumber <= 12) {
      return monthNames[monthNumber - 1];
    } else {
      return "Invalid Month";
    }
  };
  const handleFiscalYearChang = (event) => {
    const newFiscalYear = event.target.value;
    setSelectedFiscalYea(newFiscalYear);
    setSelectedMonth(null);
  };

  const handleMonthChange = (event) => {
    const selectedMonthValu = event.target.value;
    console.log(event.target.value);
    setSelectedMonth(selectedMonthValu);
    // You can log the selected month and year to the console here
    const [selectedMonthNumberEvent, selectedYearNumberEvent] =
      selectedMonthValu.split("-");
    setSelectedMonthNumber(selectedMonthNumberEvent);
    setSelectedYearNumber(selectedYearNumberEvent);
  };
  const handleFiscalYearChan = (year) => {
    setSelectedFiscalYea(year);
    setSelectedMonth(null);
  };
  const fiscalYearMenu = (
    <Menu onClick={(e) => handleFiscalYearChan(e.key)}>
      {fiscalYear.map((year) => (
        <Menu.Item key={year}>{year}</Menu.Item>
      ))}
    </Menu>
  );

  useEffect(() => {
    getAttendanceSimpleView();
  }, [
    selectedMonthNumber,
    departmentsSelected,
    selectedDepartment,
    selectedDesignation,
  ]);
  const getAttendanceSimpleView = async () => {
    const token = localStorage.getItem("authToken");
    let filterData;
    if (departmentsSelected) {
      filterData = {
        department: departmentsSelected,
      };
    } else {
      filterData = {};
    }
    try {
      const fetchData = async () => {
        const response = await fetch(
          `${BASE_URL}/${FetchAttendanceSimpleView}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `${token}`,
            },
            body: JSON.stringify({
              month: parseInt(selectedMonthNumber),
              year: parseInt(selectedYearNumber),
              department: selectedDepartment,
              designation: selectedDesignation,
            }),
          }
        );

        if (response.ok) {
          const data = await response.json();
          setSimpleViewData(data?.data);
          const transformedData = data?.data?.map(
            ({ staffData, attendanceDetails }) => {
              const rowData = {
                Name: `${staffData?.firstName} ${staffData?.lastName}`,
                Designation: staffData?.department?.departmentName,
                Department: staffData?.designationName,
              };

              attendanceDetails.forEach((detail) => {
                rowData[`${getMonthName(selectedMonthNumber)} ${detail.day}`] =
                  detail.isAbsent
                    ? "Absent"
                    : detail.isWeeklyOff
                    ? "WeeklyOff"
                    : detail.isPresent
                    ? "Present"
                    : "";
              });

              return rowData;
            }
          );
          console.log('transformedData',transformedData)
          setSimpleExportData(transformedData);
        } else {
          const data = await response.json();
          console.log("departmenterr", data);
          toast.error(data.errorMessage, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      };
      await fetchData();
    } catch (error) {
      console.error("Error updating designation:", error);
    }
  };
  const maxDays = Math.max(
    ...simpleViewData.map(({ attendanceDetails }) => attendanceDetails.length)
  );

  const disabledData = simpleViewData.map(
    ({ staffData, attendanceDetails }) => ({
      firstName: staffData.firstName,
      lastName: staffData.lastName,
      logo: staffData.logo,
      faceRegisterUrl: staffData.faceRegisterUrl,
      designationName: staffData.designationName,

      ...attendanceDetails.reduce((acc, detail) => {
        acc[`day_${detail.day}`] = {
          isAbsent: detail.isAbsent,
          isPresent: detail.isPresent,
          isWeeklyOff: detail.isWeeklyOff,
          attendance: detail.attendance,
        };
        return acc;
      }, {}),
    })
  );
  // Create column definitions dynamically
  const simpleColumns = [
    {
      headerName: "Name",
      field: "firstName",
      width: 200,
      pinned: "left",
      cellRenderer: (params) => {
        return (
          <>
            <div className="nameMain">
              <Row className="flex items-center flex-nowrap">
                <Col className="!mr-2">
                  <img
                    className="hisimage mr-1 min-w-[28px]"
                    style={{
                      width: "28px",
                      height: "28px",
                      borderRadius: "50%",
                    }}
                    src={params?.data?.faceRegisterUrl || params?.data?.logo}
                    alt=""
                  />
                </Col>
                <Col sm={18} className="nameMain ">
                  <p className="text-sm font-sbold">
                    {capitalizeFirstLetter(params?.data?.firstName)}{" "}
                    {capitalizeFirstLetter(params?.data?.lastName)}
                  </p>
                  <p className="text-xs">
                    {capitalizeFirstLetter(params?.data?.designationName)}
                  </p>
                </Col>
              </Row>
            </div>
          </>
        );
      },
    },

    ...Array.from({ length: maxDays }, (_, index) => ({
      headerName: `${getMonthName(selectedMonthNumber)} ${index + 1}`,
      field: `day_${index + 1}`,
      cellRenderer: "agGroupCellRenderer",
      width: 75,
      maxWidth: 75,
      cellRendererParams: {
        innerRenderer: (params) => {
          const { isAbsent, isPresent, isWeeklyOff, attendance } = params.value;
          return (
            <div>
              {isAbsent && attendance.length > 0 && (
                <span className="absent-a">A</span>
              )}
              {isPresent && <span className="preasent-p">P</span>}
              {isWeeklyOff && (
                <span className="Ot !w-[40px] text-xs !py-[8px]">WO</span>
              )}
            </div>
          );
        },
      },
      width: 150,
    })),
  ];

  useEffect(() => {
    const transformedData = simpleViewData.map(
      ({ staffData, attendanceDetails }) => {
        const rowData = {
          Name: `${staffData?.firstName} ${staffData?.lastName}`,
          Designation: staffData?.department?.departmentName,
          Department: staffData?.designationName,
        };

        attendanceDetails.forEach((detail) => {
          rowData[`${getMonthName(selectedMonthNumber)} ${detail.day}`] =
            detail.isAbsent
              ? "A"
              : detail.isWeeklyOff
              ? "WO"
              : detail.isPresent
              ? "P"
              : "";
        });

        return rowData;
      }
    );
    // Update state with the transformed data
  }, [simpleViewData]);

  const [size, setSize] = useState("july");

  const handleSizeChange = (e) => {
    setSize(e.target.value);
  };
  // const scroll = { x: 1150 };

  const [openDepartment, setOpenDepartment] = useState(false);
  const handleDepartmentOpenChange = (nextOpen, info) => {
    setOpenDepartment(nextOpen);
  };
  const [openDesignation, setOpenDesignation] = useState(false);
  const handleDesignationOpenChange = (nextOpen, info) => {
    setOpenDesignation(nextOpen);
  };
  const handleDeptMenuClick = ({ key }) => {
    const updatedItems = [...selectedDepartment];
    const index = updatedItems.indexOf(key);
    if (index === -1) {
      updatedItems.push(key);
    } else {
      updatedItems.splice(index, 1);
    }
    setSelectedDepartment(updatedItems);
  };
  const dept = (
    <Menu onClick={handleDeptMenuClick}>
      {departments?.map((department) => (
        <Menu.Item className="checktext" key={department.key}>
          <Checkbox
            className="mr-1"
            checked={selectedDepartment.includes(department.key)}
          />
          {department.value}
        </Menu.Item>
      ))}
    </Menu>
  );
  const handleDesigMenuClick = ({ key }) => {
    const updatedItems = [...selectedDesignation];
    const index = updatedItems.indexOf(key);
    if (index === -1) {
      updatedItems.push(key);
    } else {
      updatedItems.splice(index, 1);
    }
    setSelectedDesignationt(updatedItems);
  };
  const desig = (
    <Menu onClick={handleDesigMenuClick}>
      {designation.map((designation) => (
        <Menu.Item className="checktext" key={designation.key}>
          <Checkbox
            className="mr-1"
            checked={selectedDesignation.includes(designation.key)}
          />
          {designation.value}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <div className="p-3">
      <Row className="justify-content-between">
        <Col sm={15}>
          <div className="flex defaulTabs gap-3">
            <Radio.Group
              className="radioBtnMonths !bg-[#F1F6FD]"
              value={selectedMonth}
              onChange={(e) => handleMonthChange(e)}
            >
              {updateMonths(selectedFiscalYea).map((month) => (
                <Radio.Button
                  key={month}
                  value={month}
                  className="text-center !px-4 !py-[5px] !rounded-[11px]"
                  style={{
                    backgroundColor: `${
                      selectedMonth === month ? "#00305F" : "transparent"
                    }`,
                    color: `${selectedMonth === month ? "white" : "black"}`,
                    borderColor: `${
                      selectedMonth === month ? "#363743" : "transparent"
                    }`,
                  }}
                >
                  <div className="text-[17px] font-sbold">
                    {monthNames[parseInt(month.split("-")[0]) - 1]}
                  </div>
                  <div className="text-[11px] font-normal leading-none">
                    {month.split("-")[1]}
                  </div>
                </Radio.Button>
              ))}
            </Radio.Group>

            <Dropdown overlay={fiscalYearMenu} placement="bottom">
              <Button className="bg-[#F1F6FD] border-[#F1F6FD] font-semibold h-[38px] flex items-center !pr-3 !outline-none">
                {selectedFiscalYea}{" "}
                <FaAngleDown className="ml-2 text-xs text-[#4B8AEB]" />
              </Button>
            </Dropdown>
          </div>
        </Col>
        <Col sm={3}>
          <div className="simple-time-last-icon gap-3">
            <Dropdown
              overlay={dept}
              trigger={["click"]}
              placement="bottom"
              onOpenChange={handleDepartmentOpenChange}
              open={openDepartment}
            >
              <Button className="bg-[#F1F6FD] border-[#F1F6FD] font-semibold h-[38px] flex items-center !pr-3 !outline-none">
                Department{" "}
                <FaAngleDown className="ml-2 text-xs text-[#4B8AEB]" />
              </Button>
            </Dropdown>
            <Dropdown
              overlay={desig}
              trigger={["click"]}
              placement="bottom"
              onOpenChange={handleDesignationOpenChange}
              open={openDesignation}
            >
              <Button className="bg-[#F1F6FD] border-[#F1F6FD] font-semibold h-[38px] flex items-center !pr-3 !outline-none">
                Designation{" "}
                <FaAngleDown className="ml-2 text-xs text-[#4B8AEB]" />
              </Button>
            </Dropdown>
            {/* <UploadOutlined className='simple-time-upload' /> */}
            {simpleViewData?.length > 0 && (
              <ExportToExcel
                apiData={simpleExportData}
                fileName={"SimpleAttendanceData"}
              />
            )}
            {isSearchVisible && (
              <input
                type="text"
                id="filter-text-box"
                className="border-bottom h-[38px] !border-[#B7D0F7] outline-none"
                placeholder="Search..."
                onInput={onFilterTextBoxChanged}
              />
            )}
            <img
              src={SearchIconColor}
              onClick={toggleSearchVisibility}
              className="cursor-pointer"
            />
          </div>
        </Col>
      </Row>

      <div
        className="ag-theme-alpine text-base border-none font-proxima !mt-5 lessPadding"
        style={{ height: "500px", width: "100%" }}
      >
        <AgGridReact
          className="fw600"
          columnDefs={simpleColumns.reverse()}
          rowData={disabledData}
          domLayout="autoHeight"
          pagination={true}
          getRowHeight={() => 50}
          paginationPageSize={20}
          ref={gridRef}
          paginationPageSizeSelector={false}
        />
      </div>
    </div>
  );
}

export default SimpleView;
